import React from 'react';
import Helmet from 'react-helmet';

const MetaInfo = (props) => {

    return (
        <>
            {props.lang !== 'fr' ?
                <Helmet>
                    <title>Our Tomatoes</title>
                    <meta name="description" content="At A&W, our tomatoes are grown without the use of herbicides and hand-picked once ripe." />
                </Helmet>
            :
                <Helmet>
                    <title>Nos tomates</title>
                    <meta name="description" content="Chez A&W, nos tomates sont cultivées sans l’utilisation d’herbicides et cueillies à la main une fois mûres à point." />
                </Helmet>
            }
        </>
    )
}
export default MetaInfo;